export default __webpack_public_path__ + "static/media/facebook.795fce8e.png";